<template>
  <div class="page">
    <div class="card">
      <button class="back-btn" type="button" @click="$router.back()">← Назад</button>

      <p v-if="errorMessage" class="message error">{{ errorMessage }}</p>

      <div v-if="detailsLoading && !order" class="loading-box">
        Загрузка...
      </div>

      <div v-else-if="order" class="details">
        <div class="details-head">
          <div>
            <div class="order-number">{{ order.order_number }}</div>
            <h1 class="full-text">{{ order.product_name }}</h1>
          </div>
          <span :class="['status', statusClass(order.status)]">{{ order.status }}</span>
        </div>

        <div v-if="isAdmin" class="text-block sender-block">
          <div class="text-block__title">Отправитель</div>
          <div class="sender-grid">
            <div class="info-box">
              <span>ФИО</span>
              <strong>{{ order.user_FIO || '—' }}</strong>
            </div>

            <div class="info-box">
              <span>Телефон</span>
              <strong>{{ order.user_phone || '—' }}</strong>
            </div>

            <div class="info-box">
              <span>Email</span>
              <strong>{{ order.user_email || '—' }}</strong>
            </div>

            <div class="info-box">
              <span>Telegram</span>
              <strong>{{ order.user_tg || '—' }}</strong>
            </div>

            <div class="info-box">
              <span>VK</span>
              <strong>{{ order.user_vk || '—' }}</strong>
            </div>
          </div>
        </div>

        <div class="info-grid">
          <div class="info-box">
            <span>Ткань</span>
            <strong class="full-text">{{ order.fabric_name || '—' }}</strong>
          </div>

          <div class="info-box">
            <span>Количество</span>
            <strong>{{ order.quantity || '—' }}</strong>
          </div>

          <div class="info-box">
            <span>Срок</span>
            <strong>{{ formatDate(order.deadline_date) }}</strong>
          </div>

          <div class="info-box">
            <span>Рисунок изголовья</span>
            <strong class="full-text">{{ order.headboard_pattern || '—' }}</strong>
          </div>
        </div>

        <div v-if="isAdmin" class="status-panel">
          <div class="status-panel__title">Изменить статус</div>

          <div class="status-panel__row">
            <select v-model="selectedStatus" class="status-select">
              <option v-for="status in statuses" :key="status" :value="status">
                {{ status }}
              </option>
            </select>

            <button class="save-status-btn" type="button" :disabled="statusLoading || selectedStatus === order.status" @click="saveStatus">
              {{ statusLoading ? 'Сохраняем...' : 'Сохранить статус' }}
            </button>
          </div>
        </div>

        <div class="text-block">
          <div class="text-block__title">Комментарий</div>
          <div class="text-block__body full-text">{{ order.comment || 'Нет комментария' }}</div>
        </div>

        <div v-if="order.files && order.files.length" class="photos-block">
          <div class="text-block__title">Фото</div>
          <div class="photos-grid">
            <img
              v-for="file in order.files"
              :key="file.id"
              :src="file.file_url"
              alt=""
              class="photo-item"
              @click="openImage(file.file_url)"
            />
          </div>
        </div>
      </div>

      <div v-else class="empty-box">
        Заявка не найдена
      </div>
    </div>

    <div v-if="fullscreenImage" class="image-modal" @click="closeImage">
      <button type="button" class="image-modal__close" @click.stop="closeImage">×</button>
      <img :src="fullscreenImage" alt="" class="image-modal__content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'RequestDetailsView',
  data() {
    return {
      fullscreenImage: '',
      selectedStatus: 'Создана',
      statuses: ['Создана', 'Принято', 'В процессе', 'Отклонено', 'Завершено']
    }
  },
  computed: {
    isAdmin() {
      return this.$store.getters['auth/isAdmin']
    },
    order() {
      return this.$store.getters['orders/currentOrder']
    },
    detailsLoading() {
      return this.$store.getters['orders/detailsLoading']
    },
    statusLoading() {
      return this.$store.getters['orders/statusLoading']
    },
    errorMessage() {
      return this.$store.getters['orders/error']
    }
  },
  async mounted() {
    const result = await this.$store.dispatch('orders/fetchOrder', this.$route.params.orderNumber)

    if (result?.order?.status) {
      this.selectedStatus = result.order.status
    }
  },
  beforeUnmount() {
    this.$store.dispatch('orders/clearCurrentOrder')
  },
  watch: {
    order: {
      immediate: true,
      handler(value) {
        if (value?.status) {
          this.selectedStatus = value.status
        }
      }
    }
  },
  methods: {
    statusClass(status) {
      switch (status) {
        case 'Создана':
          return 'status--created'
        case 'Принято':
          return 'status--accepted'
        case 'В процессе':
          return 'status--progress'
        case 'Отклонено':
          return 'status--rejected'
        case 'Завершено':
          return 'status--completed'
        default:
          return 'status--default'
      }
    },
    formatDate(value) {
      if (!value) return '—'
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return value
      return date.toLocaleDateString()
    },

    openImage(url) {
      this.fullscreenImage = url
    },

    closeImage() {
      this.fullscreenImage = ''
    },

    async saveStatus() {
      if (!this.order?.order_number || !this.isAdmin) {
        return
      }

      await this.$store.dispatch('orders/updateOrderStatus', {
        order_number: this.order.order_number,
        status: this.selectedStatus
      })
    }
  }
}
</script>

<style scoped>
.page {
  padding: 12px;
}

.card {
  max-width: 760px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 22px;
  padding: 22px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
}

.back-btn {
  border: none;
  background: #eef2ff;
  color: #1d4ed8;
  padding: 12px 14px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
  margin-bottom: 18px;
  font-size: 12px;
}

.details-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
}

.order-number {
  color: #2563eb;
  font-weight: 800;
  margin-bottom: 8px;
}

h1 {
  margin: 0;
  font-size: 28px;
}

.status {
  border-radius: 999px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  border: 1px solid transparent;
}

.status--created {
  background: #ecfdf5;
  color: #374151;
  border-color: #9fd8c8
}

.status--accepted {
  background: #dbeafe;
  color: #1d4ed8;
  border-color: #bfdbfe;
}

.status--progress {
  background: #fef3c7;
  color: #b45309;
  border-color: #fde68a;
}

.status--rejected {
  background: #fee2e2;
  color: #b91c1c;
  border-color: #fecaca;
}

.status--completed {
  background: #dcfce7;
  color: #15803d;
  border-color: #bbf7d0;
}

.status--default {
  background: #f3f4f6;
  color: #4b5563;
  border-color: #e5e7eb;
}

.info-grid,
.sender-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 18px;
}

.sender-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-bottom: 0;
}

.info-box {
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 16px;
}

.info-box span {
  display: block;
  color: #6b7280;
  margin-bottom: 8px;
}

.text-block,
.status-panel {
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 18px;
}

.text-block__title,
.status-panel__title {
  font-weight: 800;
  margin-bottom: 10px;
}

.text-block__body {
  color: #334155;
  line-height: 1.5;
}

.status-panel__row {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.status-select {
  flex: 1 1 260px;
  min-height: 48px;
  border: 1px solid #dbe3f0;
  border-radius: 14px;
  padding: 12px 14px;
  background: #f8fafc;
  outline: none;
}

.save-status-btn {
  border: none;
  border-radius: 14px;
  background: #111827;
  color: #ffffff;
  padding: 14px 16px;
  font-weight: 700;
  cursor: pointer;
}

.save-status-btn[disabled] {
  opacity: 0.65;
  cursor: default;
}

.photos-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.photo-item {
  width: 100%;
  height: 140px;
  object-fit: cover;
  border-radius: 14px;
  cursor: pointer;
}

.loading-box,
.empty-box {
  border: 1px dashed #cbd5e1;
  border-radius: 16px;
  padding: 28px;
  text-align: center;
  color: #64748b;
}

.message {
  margin: 0 0 16px;
  padding: 14px 16px;
  border-radius: 14px;
}

.message.error {
  background: #f7dede;
  color: #c52f2f;
}

.image-modal {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 500;
  padding: 24px;
}

.image-modal__content {
  max-width: 100%;
  max-height: 100%;
  border-radius: 18px;
}

.image-modal__close {
  position: absolute;
  top: 18px;
  right: 18px;
  width: 46px;
  height: 46px;
  border: none;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  color: #ffffff;
  font-size: 28px;
  cursor: pointer;
}

.break-title {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

@media (max-width: 768px) {
  .info-grid,
  .sender-grid,
  .photos-grid {
    grid-template-columns: 1fr;
  }

  .details-head {
    flex-direction: column;
  }
}

.full-text {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.sender-block {
  background-color: #f8f8f8;
}
.sender-block .info-box {
  background-color: white;
}
</style>